import React from 'react';
import { FormattedMessage } from 'react-intl';
import message from '../../Containers/ManualSearchV2/ManualSearchMessages';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    // eslint-disable-next-line no-console
    console.error(error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <h2> <FormattedMessage {...message.somethingWentwrongLabel} /></h2>;
    }
    return children;
  }
}

export default ErrorBoundary;
